'use client';

import React, {FC} from 'react';
import Image from 'next/image';
import {useRouter} from 'next/navigation';

import {Button} from '@zoefin/design-system';

import {addToDataLayer} from '../../../../utils/pageUtils';

import styles from './styles.module.scss';

const Product: FC = () => {
  const {push} = useRouter();

  const addToDataLayerHomePage = (section: string, label: string) => {
    addToDataLayer({
      overrideBase: 'Portal_Landing_Page',
      values: {
        Section: section,
        Label: label,
      },
    });
  };

  const redirectOnBoarding = (section: string, label: string) => {
    addToDataLayerHomePage(section, label);
    push('/onboarding');
  };

  return (
    <section className={styles['section-product']}>
      <div className="default-container">
        <div
          className={`${styles.hero} ${styles['hero--secondary']} ${styles['hero--inverse']}`}>
          <div data-testid="product-picture" className={styles.hero__picture}>
            <Image
              src="/static/img/homepage/mockup-mobile-app.png"
              alt="Mobile app mockup"
              width="268"
              height={777}
            />
            <p className={styles.hero__picture_disclosure}>
              Disclosure: The information in the visuals is for informational
              purposes only, and does not represent an actual user&apos;s
              account, balance, or return and does not represent target or
              projected performance of any user’s account.
            </p>
          </div>
          <div
            className={`${styles.hero__text} ${styles['hero--secondary__text']} ${styles['hero--inverse__text']}`}>
            <h4>
              <b>Exceptional Client Experience & Innovative Technology</b>
            </h4>
            <p data-testid="paragraph">
              We use innovative technology and exceptional client service to
              help grow and protect your wealth.
            </p>
            <Button
              onClick={() => redirectOnBoarding('Mock 2', 'Get Started')}
              as="button">
              Find An Advisor
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
